export class ApiError extends Error {
  constructor(message: string, public status: number) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 10000);

  try {
    const response = await fetch(url, { ...init, signal: controller.signal });
    const contentType = response.headers.get('content-type') ?? '';
    if (!contentType.includes('application/json')) {
      throw new ApiError(`Expected JSON but received ${contentType || 'an unknown response type'}`, response.status);
    }

    const data = await response.json() as T & { error?: string; message?: string };
    if (!response.ok) {
      throw new ApiError(data.error ?? data.message ?? `Request failed with HTTP ${response.status}`, response.status);
    }
    return data;
  } finally {
    window.clearTimeout(timeout);
  }
}
